import {
    GET_PROJECT_CORRESPONDENCE_ENTRIES_REQUEST,
    GET_PROJECT_CORRESPONDENCE_ENTRIES_ERROR,
    GET_PROJECT_CORRESPONDENCE_ENTRIES_SUCCESS,
    CREATE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST,
    CREATE_PROJECT_CORRESPONDENCE_ENTRY_ERROR,
    CREATE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS,
    UPDATE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST,
    UPDATE_PROJECT_CORRESPONDENCE_ENTRY_ERROR,
    UPDATE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS,
    DELETE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST,
    DELETE_PROJECT_CORRESPONDENCE_ENTRY_ERROR,
    DELETE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS,
    SET_DATA_IS_OBJECT
  } from "../../actions/types";
  import reducers from "../common"
  
  const initialState = {};
  export default (state = initialState, action) => {
  
    reducers.init(reducers);
  
    reducers.GET_ENTITY_REQUEST = GET_PROJECT_CORRESPONDENCE_ENTRIES_REQUEST;
    reducers.GET_ENTITY_ERROR = GET_PROJECT_CORRESPONDENCE_ENTRIES_ERROR;
    reducers.GET_ENTITY_SUCCESS = GET_PROJECT_CORRESPONDENCE_ENTRIES_SUCCESS;
    reducers.CREATE_ENTITY_REQUEST = CREATE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST;
    reducers.CREATE_ENTITY_ERROR = CREATE_PROJECT_CORRESPONDENCE_ENTRY_ERROR;
    reducers.CREATE_ENTITY_SUCCESS = CREATE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS;
    reducers.UPDATE_ENTITY_REQUEST = UPDATE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST;
    reducers.UPDATE_ENTITY_ERROR = UPDATE_PROJECT_CORRESPONDENCE_ENTRY_ERROR;
    reducers.UPDATE_ENTITY_SUCCESS = UPDATE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS;
    reducers.DELETE_ENTITY_REQUEST = DELETE_PROJECT_CORRESPONDENCE_ENTRY_REQUEST;
    reducers.DELETE_ENTITY_ERROR = DELETE_PROJECT_CORRESPONDENCE_ENTRY_ERROR;
    reducers.DELETE_ENTITY_SUCCESS = DELETE_PROJECT_CORRESPONDENCE_ENTRY_SUCCESS;
    reducers.SET_DATA_IS_OBJECT = SET_DATA_IS_OBJECT;
    reducers.entityName = "projectCorrespondenceEntries";
  
    return reducers.entity(reducers)(state, action);
  };